import { render, staticRenderFns } from "./ServerFilterableTable.vue?vue&type=template&id=bc665076"
import script from "./ServerFilterableTable.vue?vue&type=script&lang=js"
export * from "./ServerFilterableTable.vue?vue&type=script&lang=js"
import style0 from "./ServerFilterableTable.vue?vue&type=style&index=0&id=bc665076&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports